import { StaticLineage } from "@altimateai/ui-components/lineage";
import { z } from "zod";
import { pageSchema } from "@/helpers/types";
import { BaseUserSchema } from "@/types";

// Zod schema for export lineage item (matches backend ExportLineageResponse)
export const GetExportLineageItemSchema = z.object({
  id: z.coerce.string(),
  name: z.string(),
  lineage_data: z.record(z.unknown()),
  created_at: z.string().nullable().optional(),
  updated_at: z.string().nullable().optional(),
  created_by: z.number().nullable().optional(),
  last_modified_by: z.number().nullable().optional(),
  user: BaseUserSchema.nullable().optional(),
});

// Paginated export lineage response schema
export const GetExportLineagePageSchema = pageSchema(GetExportLineageItemSchema);

export type GetExportLineageItem = z.infer<typeof GetExportLineageItemSchema> & {
  lineage_data: StaticLineage;
};
